import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const createPricingTest = {
  name: "createPricingTest" as const,
  input: z.object({
    name: z.string(),
    variants: z
      .array(
        z.object({
          variantId: z.string(),
          productId: z.string(),
          productTitle: z.string(),
          variantTitle: z.string(),
          controlPrice: z.number(),
          variantPrice: z.number(),
        }),
      )
      .min(1),
  }),
  output: z.object({ pricingTestId: zExt.objectId() }),
};
